<script setup lang="ts">
import { EnumerationOptionDto, EnumerationValueListDto } from '@/api/generator';
import EnumerationValueList from '@/components/forms/dataTypes/EnumerationValueList.vue';
import { VeeEnumerationValueListProps } from '@/components/forms/types.ts';
import { useField } from 'vee-validate';
import { computed, toRef } from 'vue';
import { useVeeFormProps } from '../utils';

const props = defineProps<VeeEnumerationValueListProps>();

const veeProps = useVeeFormProps(props);

const {
  value,
  meta,
  validate: validateBase,
  errorMessage: errorMessageBase,
  handleChange,
  handleBlur,
} = useField<EnumerationValueListDto>(
  toRef(() => props.name),
  undefined,
  {
    validateOnValueUpdate: true,
  },
);

const { validate: validateSelectedOptions, errorMessage: errorMessageOptions } = useField<
  Array<EnumerationOptionDto> | undefined
>(toRef(() => `${props.name}.selectedOptions`));

function validate() {
  validateBase();
  validateSelectedOptions();
}

function onUpdate(input: EnumerationValueListDto | undefined) {
  handleChange(input, false);

  if (meta.touched) {
    validate();
  }
}

function onBlur(event: InputEvent) {
  handleBlur(event, false);
  validate();
}

const errorMessage = computed(() => errorMessageBase.value || errorMessageOptions.value);
</script>

<template>
  <EnumerationValueList
    v-bind="veeProps"
    :errorMessage="errorMessage"
    :enumerationList="value"
    @blur="onBlur"
    @update:enumerationList="onUpdate"
  />
</template>
